import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import API_URL from '../../../utils/api';
import "./Questions.css";

const FALLBACK_QUESTIONS = [
  "What brings you joy lately?",
  "Share a challenge you're working through.",
  "What's something you're grateful for?",
  "Describe a recent meaningful conversation.",
  "What's a goal you're excited about?"
];

export default function Questions() {
  const { pairId } = useParams();
  const [pair, setPair] = useState(null);
  const [questions, setQuestions] = useState(FALLBACK_QUESTIONS);
  const [current, setCurrent] = useState(0);
  const [done, setDone] = useState(false);

  useEffect(() => {
    fetch(`${API_URL}/api/match/pair/${pairId}`)
      .then(r => r.json())
      .then(data => {
        setPair(data);
        setCurrent(data.currentQuestion || 0);
      });
  }, [pairId]);

  // Fetch AI-generated questions tailored to both users' demographics
  useEffect(() => {
    fetch(`${API_URL}/api/match/pair/${pairId}/ai-questions`)
      .then(r => r.json())
      .then(data => {
        if (data.questions && data.questions.length > 0) {
          setQuestions(data.questions);
        }
      })
      .catch(() => {
        // Keep fallback questions on error
      });
  }, [pairId]);

  const handleDone = async () => {
    setDone(true);
    await fetch(`${API_URL}/api/match/next-question`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ pairId })
    });
    setTimeout(() => {
      setDone(false);
      setCurrent(c => c + 1);
    }, 1200);
  };

  if (!pair) return (
    <div className="questions-root" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>
      <div style={{ textAlign: 'center', color: '#999' }}>
        <div style={{ fontSize: 14 }}>Loading questions...</div>
      </div>
    </div>
  );

  if (current >= questions.length) return <div className="questions-root">Session complete! Thank you.</div>;

  return (
    <div className="questions-root">
      <h2>Questions</h2>
      <div className="questions-progress">Question {current + 1} of {questions.length}</div>
      <div className="questions-card">
        <div className="questions-text">{questions[current]}</div>
        <button className="questions-done-btn" onClick={handleDone} disabled={done}>
          {done ? "Waiting..." : "I'm done"}
        </button>
      </div>
    </div>
  );
}
